import { useCallback } from "react";
import { useAppDispatch } from "../hooks";
import { postCrud } from "../slices/postSlice";
import { CreatePostData } from "../types/types";

interface PostCrudProps {
  baseUrl: string;
  method: string;
  data: CreatePostData | null;
  id: number | null;
  perPage: number
}

export const usePostRequest = () => {
  const dispatch = useAppDispatch();

  const postRequest = useCallback(async ({ baseUrl, method, data, id, perPage }: PostCrudProps): Promise<any> => {
    const dispatchData = await dispatch(postCrud({ baseUrl, method, data, id, perPage }));
    return dispatchData;
  }, [dispatch]);

  return postRequest;
};
